import React from 'react'

const IconZap = () => (
	<svg
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		role="img"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="feather feather-zap">
		<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
	</svg>
)

export default IconZap
